import React from "react";
import { Languages } from "lucide-react";

// Landing-page demo games exist in FR ("demo-x") and EN ("demo-x-en").
const DEMO_RE = /^demo-[a-z]+(-en)?$/;

export function DemoLangSwitch({ slug }) {
  if (!slug || !DEMO_RE.test(slug)) return null;
  const isEn = slug.endsWith("-en");
  const target = isEn ? slug.slice(0, -3) : `${slug}-en`;
  return (
    <a
      href={`/play/${target}`}
      lang={isEn ? "fr" : "en"}
      className="inline-flex h-9 items-center gap-1.5 rounded-full border border-white/15 bg-black/45 px-3.5 text-xs font-semibold text-white backdrop-blur-md transition-colors hover:bg-black/65"
      data-testid="demo-lang-switch"
    >
      <Languages className="h-3.5 w-3.5" />
      {isEn ? "Essayer en français" : "Try in English"}
    </a>
  );
}
